import AddExam from "../../Components/Modals/AddExam";
import Table from "../../Components/Table";
import { deleteExamById, getAllExamPagination } from "../../Services/MasterService";

const Exam = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Website",
            value: "website_url"
        },
        {
            label: "Tags",
            value: "tags"
        },
        {
            label: "Logo",
            value: "logo",
                        renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail"/>
                )
            }
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddExam data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllExamPagination}
            columns={columns}
            title={"Exams Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteExamById}
        />
    );
}

export default Exam;